import { TrendUpIcon as PhosphorTrendUpIcon } from "@phosphor-icons/react/dist/ssr/TrendUp";

import { createAppIcon } from "@/components/createAppIcon";

export const TrendingUpIcon = /* @__PURE__ */ createAppIcon(PhosphorTrendUpIcon);
